<template>
  <btn
    v-if="startOver"
    @click="back"
  >
    {{ label }}
  </btn>
  <button
    v-else
    class="quiz-back t-heading-9"
    @click="back"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="21px"
      height="11px"
      viewBox="0 0 21 11"
    >
      <!-- Generator: sketchtool 58 (101010) - https://sketch.com -->
      <title>Back</title>
      <desc>Created with sketchtool.</desc>
      <g
        id="Homepage"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="D-HP-Default-Copy-2"
          transform="translate(-629.000000, -3784.000000)"
          fill="#022840"
          fill-rule="nonzero"
        >
          <path
            id="Combined-Shape-Copy"
            d="M643.173948,3784.14453 L649.695061,3788.63624 C649.925844,3788.79324 650.036042,3789.04952 649.989522,3789.29884 C649.991264,3789.30322 649.992159,3789.30864 649.992984,3789.31408 C650.03016,3789.55928 649.917813,3789.80355 649.698263,3789.95486 L643.173036,3794.4494 C643.036134,3794.54256 642.868351,3794.59243 642.696147,3794.59117 C642.365173,3794.59023 642.071334,3794.40209 641.964572,3794.12273 C641.857811,3793.84336 641.961663,3793.53437 642.223136,3793.35342 L647.09,3790 L629.721154,3790.00043 C629.322872,3790.00043 629,3789.71251 629,3789.35736 C629,3789.0022 629.322872,3788.71429 629.721154,3788.71429 L647.269,3788.714 L642.224647,3785.23982 C641.885467,3785.00606 641.823016,3784.57137 642.085158,3784.26892 C642.3473,3783.96646 642.834768,3783.91077 643.173948,3784.14453 Z"
            transform="translate(639.500000, 3789.295597) scale(-1, 1) translate(-639.500000, -3789.295597) "
          />
        </g>
      </g>
    </svg>
    {{ label }}
  </button>
</template>

<script>
import Btn from "../button/Btn";

export default {
  name: 'GuidedQuizBackButton',
  components: {Btn},
  props:{
    label:{
      type: String,
      default: "BACK"
    },
    startOver: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    back(){
      this.$emit("back");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.quiz-back {
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  padding: 0 0 0 rem(25px);
}
</style>
